function p(l){var r,o;const{children:e,_rcProps:n}=this.props;return((r=e==null?void 0:e.props.helpers)==null?void 0:r[l])||((o=n==null?void 0:n.helpers)==null?void 0:o[l])}export{p as getBiCallback};
//# sourceMappingURL=getBiCallbacks.js.map
